import React from "react";
import ProfitStatusBadge from "../components/ProfitStatusBadge";
import { ProfitDownloadIcon, ProfitPlusIcon } from "../components/ProfitIcons";
import {
  formatProfitCurrencyCompact,
  profitMerchants,
  profitPortalMeta,
} from "../data/profitData";

export default function ProfitMerchantsPage() {
  const [statusFilter, setStatusFilter] = React.useState("");
  const [searchQuery, setSearchQuery] = React.useState("");
  const activeMerchantCount = profitMerchants.filter(function countActive(merchant) {
    return merchant.status === "Active";
  }).length;

  const filteredMerchants = profitMerchants.filter(function filterMerchant(merchant) {
    const matchesStatus = !statusFilter || merchant.status === statusFilter;
    const query = searchQuery.toLowerCase();
    const matchesQuery =
      !query ||
      merchant.name.toLowerCase().indexOf(query) >= 0 ||
      merchant.company.toLowerCase().indexOf(query) >= 0;

    return matchesStatus && matchesQuery;
  });

  return (
    <div className="profit-page">
      <div className="profit-page-header profit-page-header-row">
        <div>
          <div className="profit-page-title">Merchants</div>
          <div className="profit-page-subtitle">
            {activeMerchantCount} active merchants · {profitPortalMeta.companyName}
          </div>
        </div>
        <button className="profit-button profit-button-primary" type="button">
          <ProfitPlusIcon />
          Refer New Merchant
        </button>
      </div>

      <div className="profit-filters-bar">
        <select
          className="profit-select"
          value={statusFilter}
          onChange={function handleFilterChange(event) {
            setStatusFilter(event.target.value);
          }}
        >
          <option value="">All Status</option>
          <option value="Active">Active</option>
          <option value="Suspended">Suspended</option>
        </select>
        <input
          className="profit-select profit-search-input"
          type="text"
          placeholder="Search merchants…"
          value={searchQuery}
          onChange={function handleSearchChange(event) {
            setSearchQuery(event.target.value);
          }}
        />
        <div className="profit-spacer" />
        <button className="profit-button profit-button-outline" type="button">
          <ProfitDownloadIcon />
          Export CSV
        </button>
      </div>

      <div className="profit-tabs">
        <button className="profit-tab active" type="button">
          All ({filteredMerchants.length})
        </button>
        <button className="profit-tab" type="button">
          Active
        </button>
        <button className="profit-tab" type="button">
          Suspended
        </button>
      </div>

      <div className="profit-card profit-card-table">
        <div className="profit-table-wrap">
          <table className="profit-table">
            <thead>
              <tr>
                <th>Merchant Name</th>
                <th>Company</th>
                <th>Onboarded</th>
                <th>Base MDR</th>
                <th>Final MDR</th>
                <th>Spread</th>
                <th>Volume (SGD)</th>
                <th>Your Share</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {filteredMerchants.map(function renderMerchant(merchant) {
                return (
                  <tr key={merchant.id}>
                    <td className="profit-table-strong">{merchant.name}</td>
                    <td>{merchant.company}</td>
                    <td className="profit-mono">{merchant.onboarded}</td>
                    <td className="profit-mono">{merchant.baseMDR.toFixed(2)}%</td>
                    <td className="profit-mono">{merchant.finalMDR.toFixed(2)}%</td>
                    <td>
                      <span className="profit-badge profit-badge-blue">
                        {merchant.spread.toFixed(2)}%
                      </span>
                    </td>
                    <td className="profit-mono">
                      {formatProfitCurrencyCompact(merchant.volume)}
                    </td>
                    <td className="profit-mono profit-positive">
                      SGD {merchant.share.toFixed(2)}
                    </td>
                    <td>
                      <ProfitStatusBadge status={merchant.status} />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="profit-card-footer">
          <span>Showing {filteredMerchants.length} merchants</span>
          <div className="profit-pagination">
            <button className="profit-button profit-button-outline" type="button">
              ← Prev
            </button>
            <button className="profit-button profit-button-outline" type="button">
              Next →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
